class MessageQueue {
  private messagesBuffer = [];

  private eventListeners = {};

  init() {
    window.addEventListener('message', (event: any) => {
      if (this.eventListeners[event.data.eventName]) {
        this.eventListeners[event.data.eventName].forEach((cb) => {
          cb(event);
        });
        return;
      }

      this.messagesBuffer.push(event);
    });
  }

  /**
   *
   * Attach event listener to window object and listen for messages
   *
   * @param eventName - event name
   * @param callback - callback function
   * @returns - function to remove event listener
   */
  on(eventName: string, callback: (event: any) => void) {
    this.messagesBuffer.forEach((event) => {
      if (event.data.eventName === eventName) {
        callback(event);

        // remove event from buffer
        this.messagesBuffer = this.messagesBuffer.filter((e) => e !== event);
      }
    });

    if (this.eventListeners[eventName] !== void 0) {
      this.eventListeners[eventName].push(callback);
    } else {
      this.eventListeners[eventName] = [callback];
    }

    return () => {
      this.eventListeners[eventName] = this.eventListeners[eventName].filter(
        (cb) => cb !== callback
      );
    };
  }

  off(eventName: string) {
    this.eventListeners[eventName] = [];
  }

  fireInIframe(iframe: HTMLIFrameElement, eventName: string, payload: any) {
    iframe.contentWindow.postMessage({ eventName, payload }, '*');
  }
}

export default new MessageQueue();
